import {
  Grid,
  Typography,
  IconButton,
  withStyles,
  Menu,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { useState } from "react";
import CustomMenuItem from "./CustomMenuItem";
import { ExpandLess } from "@material-ui/icons";
import { useSelector } from "react-redux";

const iconStyles = {
  selectIcon: {
    color: "#808080",
  },
};

const CustomExpandMore = withStyles(iconStyles)(
  ({ className, classes, ...rest }) => {
    return (
      <ExpandMoreIcon
        {...rest}
        className={clsx(className, classes.selectIcon)}
      />
    );
  }
);

const Dropdown = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const setValue = props.setValue;
  const isDesktopOrLaptop = useSelector((state) => state.screenSize.value);
  const filters = useSelector((state) => state.filters.value);

  const useStyles = makeStyles(() => ({
    menuItem: {
      backgroundColor: "red",
    },
    menu: {
      "& .MuiPaper-root": {
        backgroundColor: "#fff",
        borderRadius: "15px",
        boxShaddow: "solid 5px red",
        border: "solid 1.5px #808080",
        borderTopLeftRadius: "0px",
        borderTopRightRadius: "0px",
        borderTop: anchorEl ? 0 : "auto",
        maxHeight: isDesktopOrLaptop
          ? "auto"
          : props.type === "Continent" || props.type === "Country"
          ? "192px"
          : "auto",
        boxShaddow: 0,
      },
      "& .MuiPaper-elevation8": {
        boxShaddow: 0,
      },

      "& div": {
        // this is just an example, you can use vw, etc.
        width: isDesktopOrLaptop ? "200px" : "150px",
      },
    },
  }));
  const classes = useStyles();

  return (
    <Grid
      item
      style={{
        display: "flex",
        justifyContent: "flex-start",
        width: isDesktopOrLaptop ? "203px" : "153px",
        height: isDesktopOrLaptop ? "43px" : "38px",
        borderRadius: "20px",
        borderBottomRightRadius: anchorEl ? "0px" : "20px",
        borderBottomLeftRadius: anchorEl ? "0px" : "20px",
        border: "solid 1.5px #808080",
        borderBottom: anchorEl ? 0 : "solid 1.5px #808080",
      }}
      onClick={(event) => {
        anchorEl ? setAnchorEl(null) : setAnchorEl(event.currentTarget);
      }}
    >
      <div
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Grid
          item
          xs={10}
          style={{
            paddingLeft: isDesktopOrLaptop ? "1vw" : "12px",
            display: "flex",
            justifyContent: "flex-start",
          }}
        >
          <Typography
            style={{
              color: "#0040ff",
              fontSize: "14px",
              fontWeight: 600,
              fontFamily: "Overpass",
            }}
          >
            {props.type === "Continent"
              ? filters?.Continent
                ? filters?.Continent
                : "All"
              : props.type === "Country"
              ? filters?.Country
                ? filters.Country
                : "All"
              : filters?.order_by
              ? filters?.order_by
              : props.value}
          </Typography>
        </Grid>
        <Grid
          item
          xs={2}
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <IconButton
            onClick={(event) => {
              setAnchorEl(event.currentTarget);
            }}
          >
            {anchorEl ? <ExpandLess color="#808080" /> : <CustomExpandMore />}
          </IconButton>
        </Grid>
        <Menu
          className={classes.menu}
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => {
            setAnchorEl(null);
          }}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
          style={{ overflowY: "scroll", padding: 0 }}
        >
          {props.values?.map((value, index) => {
            return (
              <CustomMenuItem
                key={index}
                type={props.type}
                value={value}
                setIsOpen={props.setIsOpen}
              />
            );
          })}
        </Menu>
      </div>
    </Grid>
  );
};

export default Dropdown;
